module.exports = __webpack_public_path__ + "static/media/share_person10.91939d40.png";